import { Component } from 'vue-facing-decorator';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Financials/Revenues/Domain/queries';

@Component
export default class RevenuesQueries extends VueCqrs
{
	runRevenueAccountsByStrategyIdQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildRevenueAccountsByStrategyIdQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runRevenueAccountByIdQueryV1(workspaceId: number, strategyId: string, revenueId: string)
	{
		const query = q.buildRevenueAccountByIdQueryV1(workspaceId, strategyId, revenueId);
		this.$query(query);
	}
}